import { RawLink } from '@/shared/ui/RawLink'
import { RectangleElement } from '@/shared/ui/RectangleElement'
import { useTVStore, useVisibilityStore } from '@/shared/store'
import { Box } from '@mui/material'
import React, { MouseEvent } from 'react'

interface Props {
    onPopperClose?: () => void | undefined
    destinationChannelId: string
}

const EpgLinkElement = ({ onPopperClose, destinationChannelId }: Props) => {
    const { setEpgContentVisible } = useVisibilityStore()
    const { setWhatNextId } = useTVStore()

    const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
        setEpgContentVisible()
        onPopperClose && onPopperClose()
        setWhatNextId(destinationChannelId)
    }

    return (
        <Box onClick={handleClick}>
            <RawLink to={'/epg'}>
                <RectangleElement title={'EPG'} />
            </RawLink>
        </Box>
    )
}
export { EpgLinkElement }
